import InputBasico from './InputBasico'
import { h } from 'vue'
import Validations from '@/utils/Validations'
import { VTextField } from 'vuetify/lib'

/**
 * InputEmail
 */
export const InputEmail = InputBasico.extend({
	name: 'InputEmail',
	props: {
		label: { default: 'Email', type: String },
		placeholder: { default: 'teste@atta.com.vc' },
		rules: { default: () => [Validations.isValidEmail], type: Array<Function> }
	},
	data: () => ({
		isLoading: false,
		lazyValue: ''
	}),

	// methods: {
	//     validate() {
	//         //console.log(this.rules.length)
	//         return VTextField.superOptions.methods.validate.call(this)
	//     }
	// },

	mounted() {
		//this.rules = [Validations.isValidEmail]

		//If mounted with a value
		if (this.value) this.internalValue = this.value
	}
})

export default InputEmail
